import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { TextLink } from '@garnish/core';

export const RequestAccountDeletionTrigger = (props: RequestAccountDeletionTriggerProps) => {
  const { isDisabled, onRequestAccountDeletion } = props;
  const { formatMessage } = useIntl();

  return (
    <View style={styles.triggerContainer}>
      <TextLink
        testID="account.delete.trigger"
        palette="caution"
        disabled={isDisabled}
        onPress={onRequestAccountDeletion}
      >
        {formatMessage(messages.accountDeleteTrigger)}
      </TextLink>
    </View>
  );
};

type RequestAccountDeletionTriggerProps = Readonly<{
  onRequestAccountDeletion: () => void;
  isDisabled?: boolean;
}>;

const styles = StyleSheet.create({
  triggerContainer: {
    alignItems: 'center',
    marginTop: theme.spacing['10'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountDeleteTrigger: {
    defaultMessage: 'Delete account',
    description: 'Account | Delete | Trigger',
  },
});
